import React from "react";
import CreatePatient from "../../patient-page/createpatient";

const CaseManagerCreatePatient = () => {
  return <CreatePatient CaseManager="true" />;
};

export default CaseManagerCreatePatient;
